import React, { useState } from 'react';

import { KEY_CODES } from 'utility/constants';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { useAppSelector } from 'store/store';
import { getFeatureFlagByNameSelector } from 'store/selectors';
import { checkStores } from 'utility/utility';
import { getBreak } from 'utility/common-utils';
import { CTA, IFlyoutImage, StoreIdentifierName } from 'types';
import NavImageAndCTAs from '../NavImageCTAs/NavImageCTAs';
import Accordion from './Accordion';
import './Accordion.scss';

interface AccordionContainerProps {
  accordionCatData: any[];
  mobileImageAndCtasData?: INavImageAndCtas;
  dataEmCatTitle: string;
  storeIdentifierName: StoreIdentifierName;
}
interface INavImageAndCtas {
  flyoutImage: IFlyoutImage[];
  cta: CTA[];
}

export default function AccordionContainer({
  accordionCatData = [],
  mobileImageAndCtasData = { flyoutImage: [], cta: [] },
  dataEmCatTitle,
  storeIdentifierName,
}: Readonly<AccordionContainerProps>) {
  const [currentAccordionIndex, setCurrentAccordionIndex] = useState<number>();
  const featureNavOnTopEnabled = useAppSelector(getFeatureFlagByNameSelector('featureNavOnTop'));
  const setFeature = () => {
    const getDeviceType = getBreak();
    if (getDeviceType === 'mobile') {
      return true;
    }
    return false;
  };
  const [showImageData, setShowImageData] = useState(setFeature());
  const accordionHandler = (index: number, accordionData: any) => {
    if (accordionData.ch) {
      if (currentAccordionIndex === index) {
        setCurrentAccordionIndex(-1);
      } else {
        setCurrentAccordionIndex(index);
      }
    } else {
      setCurrentAccordionIndex(-1);
      window.location.href = checkStores(accordionData.u);
    }
  };

  const accordionClickHandler = (index: number, accordionData: any) => {
    accordionHandler(index, accordionData);
  };

  const accordionKeyEventHandler = (
    index: number,
    accordionData: any,
    event?: React.KeyboardEvent,
  ) => {
    if (event?.key === KEY_CODES.ENTER || event?.key === KEY_CODES.SPACE) {
      event.preventDefault();
      accordionHandler(index, accordionData);
    } else {
      setCurrentAccordionIndex(-1);
    }
  };

  const imageDataAccordionClickHandler = () => {
    setShowImageData(!showImageData);
  };

  const flattenAccordionData = () => {
    const initAccordionData = accordionCatData.map((category: any) => {
      return category.cats;
    });

    const accordionData = initAccordionData.reduce(
      (accumulator: any, currentValue: any) => accumulator.concat(currentValue),
      [],
    );
    return accordionData;
  };

  const getFeatureNavOnTop = () => {
    return (
      Object.keys(mobileImageAndCtasData.flyoutImage[0]).length > 0 && (
        <ErrorBoundaryWithLogger componentId="AccordionContainer-NavImageAndCTAs">
          <NavImageAndCTAs
            navImageAndCtas={mobileImageAndCtasData}
            showImageAndCTAData={showImageData}
            imageDataAccordionClickHandler={imageDataAccordionClickHandler}
            dataEmCatTitle={dataEmCatTitle}
            storeIdentifierName={storeIdentifierName}
            featureNavOnTopEnabled={featureNavOnTopEnabled}
          />
        </ErrorBoundaryWithLogger>
      )
    );
  };

  return (
    <div className="accordion-container">
      {featureNavOnTopEnabled && mobileImageAndCtasData.flyoutImage && <>{getFeatureNavOnTop()}</>}
      {flattenAccordionData().map((accordionCategory: any, index: number) => (
        <ErrorBoundaryWithLogger
          componentId="AccordionContainer-Accordion"
          key={`accordion-${accordionCategory}`}>
          <Accordion
            key={`accordion-${accordionCategory}`}
            accordionCatData={accordionCategory}
            accordionIndex={index}
            openAccordion={index === currentAccordionIndex}
            accordionClickHandler={accordionClickHandler}
            accordionKeyEventHandler={accordionKeyEventHandler}
            dataEmCatTitle={dataEmCatTitle}
            storeIdentifierName={storeIdentifierName}
          />
        </ErrorBoundaryWithLogger>
      ))}
      {!featureNavOnTopEnabled && mobileImageAndCtasData.flyoutImage && <>{getFeatureNavOnTop()}</>}
    </div>
  );
}
